import { array } from 'fp-ts';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { LocalizedText, useDialogAction, useFeatureFlag } from '@mews/framework';
import { DropDownButton, DropdownItem } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { CreateVoucherContainer } from '../../../enterpriseRateManagement/components/sections/components/vouchers/CreateVoucherContainer';
import { WithEnterpriseIds } from '../../../enterpriseRateManagement/types';
import { CREATE_VOUCHER_STARTING_POINT } from '../../../enterpriseRateManagement/utilities/userFlowTestIds';

export const TableHeaderRowActions = ({ enterpriseIds }: WithEnterpriseIds) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());
    const isEnterprisesSelectFieldEnabled = useFeatureFlag(FeatureFlag.enterprisesSelectFieldEnabled);

    return (
        <>
            <DropDownButton
                icon={IconName.More}
                variant="primary"
                size="small"
                disabled={!isEnterprisesSelectFieldEnabled && array.isEmpty(enterpriseIds)}
            >
                <DropdownItem
                    data-test-id={CREATE_VOUCHER_STARTING_POINT}
                    label={<LocalizedText textKey={TextKey.CreateVoucher} />}
                    onClick={handlers.handleOpen}
                />
            </DropDownButton>

            {states.isDialogOpened && (
                <CreateVoucherContainer
                    enterpriseIds={enterpriseIds}
                    isOpened={states.isDialogOpened}
                    onConfirm={handlers.handleConfirm}
                    onCancel={handlers.handleCancel}
                />
            )}
        </>
    );
};
